import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import * as React from 'react';
import styles from './Divider.module.scss.js';

var Divider = React.memo(function (props) { return jsx("div", { className: classNames(styles[props.type], props.className) }); });

export { Divider as default };
//# sourceMappingURL=Divider.js.map
